export const fontFamily = "'EH Sans', 'EH Serif'";
